export class BltSearchItemConstant {
    static readonly OPEN: string = "Open";
    static readonly CLOSED: string = "Closed";
}